// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sorteos_container__v3yL1 {
  animation: Sorteos_init__VDjVK 1s;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 16px;
}

.Sorteos_add_btn__4cr7A {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.5rem;
  width: 6.5rem;
  text-transform: capitalize;
  border-radius: 5px;
  font-size: 1rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.Sorteos_container__v3yL1 .Sorteos_header__FKwQP {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.Sorteos_container__v3yL1 .Sorteos_header__FKwQP .Sorteos_titleContainer__6YSu1 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.Sorteos_container__v3yL1 .Sorteos_header__FKwQP .Sorteos_titleContainer__6YSu1 h4 {
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
  margin-right: 10px;
}

.Sorteos_container__v3yL1 .Sorteos_filtersContainer__SkRFc .Sorteos_gameContainer__eFrhX {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Sorteos_container__v3yL1 .Sorteos_filtersContainer__SkRFc .Sorteos_gameContainer__eFrhX .Sorteos_selector__VFZaM {
  animation: Sorteos_init2__Xw5Js 0.3s 0.5s both;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  margin-bottom: 15px;
}

.Sorteos_container__v3yL1 .Sorteos_filtersContainer__SkRFc .Sorteos_gameContainer__eFrhX .Sorteos_selector__VFZaM .Sorteos_inputLabel__JzMy\\+ {
  font-family: Roboto, sans-serif;
  font-weight: 300;
  font-size: 1rem;
  margin-bottom: 5px;
}

.Sorteos_container__v3yL1 .Sorteos_filtersContainer__SkRFc .Sorteos_gameContainer__eFrhX .Sorteos_consult__4Qbax {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
}

.Sorteos_container__v3yL1 .Sorteos_filtersContainer__SkRFc .Sorteos_gameContainer__eFrhX .Sorteos_consultBtn__6qDKK:hover {
  transition: 0.3s;
  scale: 1.05;
  color: black;
}

.Sorteos_container__v3yL1 .Sorteos_filtersContainer__SkRFc .Sorteos_dates__qwMup {
  animation: Sorteos_init2__Xw5Js 0.3s 0.8s both;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.Sorteos_container__v3yL1 .Sorteos_filtersContainer__SkRFc .Sorteos_dates__qwMup p {
  margin: 0;
  margin-bottom: 10px;
  font-size: 1.2rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
}

.Sorteos_container__v3yL1 .Sorteos_filtersContainer__SkRFc .Sorteos_datePickers__6U4p0 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Sorteos_container__v3yL1 .Sorteos_filtersContainer__SkRFc .Sorteos_datePickers__6U4p0 .Sorteos_date__OGxs8 {
  margin-left: 1px;
}

.Sorteos_insertPaginate__UzVwX {
  width: 30px;
  height: 30px;
}

.Sorteos_insertPaginateButton__fqMMp {
  width: 30px;
  height: 30px;
}

/*----Table container-----*/
.Sorteos_container__v3yL1 .Sorteos_data__9U0Aa .Sorteos_tableContainer__Tmc4w {
  margin-top: 30px;
  margin-bottom: 30px;
  max-height: 80vh;
  border-radius: 10px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

@keyframes Sorteos_init__VDjVK {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes Sorteos_init2__Xw5Js {
  0% {
    transform: translateX(20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@media screen and (max-width: 500px) {
  .Sorteos_container__v3yL1 .Sorteos_header__FKwQP .Sorteos_titleContainer__6YSu1 h4 {
    font-size: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Sorteos/index.module.css"],"names":[],"mappings":"AAAA;EACE,iCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,8CAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8CAA+B;EAC/B,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  font-size: 16px;\n}\n\n.add_btn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 2.5rem;\n  width: 6.5rem;\n  text-transform: capitalize;\n  border-radius: 5px;\n  font-size: 1rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.container .header {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.container .filtersContainer .gameContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .filtersContainer .gameContainer .selector {\n  animation: init2 0.3s 0.5s both;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  margin-bottom: 15px;\n}\n\n.container .filtersContainer .gameContainer .selector .inputLabel {\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  font-size: 1rem;\n  margin-bottom: 5px;\n}\n\n.container .filtersContainer .gameContainer .consult {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-top: 30px;\n}\n\n.container .filtersContainer .gameContainer .consultBtn:hover {\n  transition: 0.3s;\n  scale: 1.05;\n  color: black;\n}\n\n.container .filtersContainer .dates {\n  animation: init2 0.3s 0.8s both;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .filtersContainer .dates p {\n  margin: 0;\n  margin-bottom: 10px;\n  font-size: 1.2rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n}\n\n.container .filtersContainer .datePickers {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .filtersContainer .datePickers .date {\n  margin-left: 1px;\n}\n\n.insertPaginate {\n  width: 30px;\n  height: 30px;\n}\n\n.insertPaginateButton {\n  width: 30px;\n  height: 30px;\n}\n\n/*----Table container-----*/\n.container .data .tableContainer {\n  margin-top: 30px;\n  margin-bottom: 30px;\n  max-height: 80vh;\n  border-radius: 10px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes init2 {\n  0% {\n    transform: translateX(20px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .container .header .titleContainer h4 {\n    font-size: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Sorteos_container__v3yL1`,
	"init": `Sorteos_init__VDjVK`,
	"add_btn": `Sorteos_add_btn__4cr7A`,
	"header": `Sorteos_header__FKwQP`,
	"titleContainer": `Sorteos_titleContainer__6YSu1`,
	"filtersContainer": `Sorteos_filtersContainer__SkRFc`,
	"gameContainer": `Sorteos_gameContainer__eFrhX`,
	"selector": `Sorteos_selector__VFZaM`,
	"init2": `Sorteos_init2__Xw5Js`,
	"inputLabel": `Sorteos_inputLabel__JzMy+`,
	"consult": `Sorteos_consult__4Qbax`,
	"consultBtn": `Sorteos_consultBtn__6qDKK`,
	"dates": `Sorteos_dates__qwMup`,
	"datePickers": `Sorteos_datePickers__6U4p0`,
	"date": `Sorteos_date__OGxs8`,
	"insertPaginate": `Sorteos_insertPaginate__UzVwX`,
	"insertPaginateButton": `Sorteos_insertPaginateButton__fqMMp`,
	"data": `Sorteos_data__9U0Aa`,
	"tableContainer": `Sorteos_tableContainer__Tmc4w`
};
export default ___CSS_LOADER_EXPORT___;
